import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { Target, Zap } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  const baseFeatures = ['✅ TOMO 1: Fundamentos de la Geología', '✅ TOMO 2: Mineralogía y Petrología', '✅ TOMO 3: Geología Estructural y Tectónica', '✅ TOMO 4: Geomorfología y Procesos Externos', '✅ TOMO 5: Geología Aplicada', '✅ TOMO 6: Recursos Naturales y Geología Argentina', '🎁 BONO 1: Banco de Actividades para Docentes', '🎁 BONO 2: Banco de Imágenes Geológicas Argentinas', '🎁 BONO 3: Banco de Evaluaciones', '🎁 BONO 4: Presentaciones para Clase', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const expertoFeatures = ['✅ TOMO 1: Fundamentos de la Geología', '✅ TOMO 2: Mineralogía y Petrología', '✅ TOMO 3: Geología Estructural y Tectónica', '✅ TOMO 4: Geomorfología y Procesos Externos', '✅ TOMO 5: Geología Aplicada', '✅ TOMO 6: Recursos Naturales y Geología Argentina', '🎁 BONO 1: Banco de Actividades para Docentes', '🎁 BONO 2: Banco de Imágenes Geológicas Argentinas', '🎁 BONO 3: Banco de Evaluaciones', '🎁 BONO 4: Presentaciones para Clase', '🗺️ NIVEL EXPERTO: Atlas Profesional de Geología Argentina', '✅ Acceso de por vida', '✅ Actualizaciones gratuitas'];
  const comparisonRows = [{
    sit: 'Ubicar recursos minerales en Argentina',
    sin: 'Lo buscás en varios sitios sin orden',
    con: 'Mapa de recursos con datos actualizados 2026'
  }, {
    sit: 'Explicar la sismicidad de Argentina',
    sin: 'Mostrás un gráfico genérico',
    con: 'Mapa sísmico INPRES con zonas 0 a 4 contextualizado'
  }, {
    sit: 'Mostrar las cuencas petroleras',
    sin: 'Buscás imágenes sueltas en Google',
    con: 'Atlas de infraestructura energética georreferenciada'
  }, {
    sit: 'Enseñar las provincias geológicas',
    sin: 'No tenés un mapa completo y pedagógico',
    con: '19 provincias geológicas descritas y cartografiadas'
  }, {
    sit: 'Preparar una salida de campo',
    sin: 'No sabés qué hay en la zona',
    con: 'Fichas de sitios de interés geológico por región'
  }, {
    sit: 'Responder sobre el litio argentino',
    sin: 'Tenés datos dispersos sin contexto',
    con: 'Mapa de salares con datos de producción y reservas 2026'
  }, {
    sit: 'Comparar relieves de Argentina',
    sin: 'Describís de memoria',
    con: 'Perfil topográfico completo O-E con altitudes reales'
  }, {
    sit: 'Referenciar con datos reales',
    sin: 'Tus estadísticas son viejas',
    con: 'Base de datos geológica argentina actualizada al 2026'
  }];
  const atlas = [{
    icon: '🌍',
    title: 'MAPA GEOLÓGICO GENERAL',
    desc: 'Descripción completa del mapa geológico de Argentina con leyenda pedagógica, distribución por edades y descripción regional del NOA, Cuyo y Patagonia. Con ficha geológica de las 23 provincias argentinas.'
  }, {
    icon: '🏔️',
    title: 'ATLAS DE PROVINCIAS GEOLÓGICAS',
    desc: 'Las 19 provincias geológicas de Argentina descriptas y cartografiadas: Puna, Cuenca Neuquina, Llanura Chacopampeana, Cordillera Patagónica y más. Cada una con recursos, riesgos y conexión con el Megapack.'
  }, {
    icon: '⛏️',
    title: 'ATLAS DE RECURSOS MINERALES',
    desc: 'Mapa de yacimientos metalíferos y no metálicos. Tabla de 12 yacimientos principales con empresa, estado 2026 y reservas. Mapa especial del litio con salares productivos, en desarrollo y en exploración.'
  }, {
    icon: '⚡',
    title: 'ATLAS DE RECURSOS ENERGÉTICOS',
    desc: 'Mapa de cuencas hidrocarburíferas, represas hidroeléctricas, centrales nucleares y parques eólicos. Tabla de producción por cuenca y datos completos de Vaca Muerta actualizados al 2026.'
  }, {
    icon: '⚠️',
    title: 'ATLAS DE RIESGOS GEOLÓGICOS',
    desc: 'Mapa sísmico INPRES con zonas 0 a 4. Tabla de grandes terremotos históricos. Mapa de riesgo volcánico. Tabla de todos los riesgos geológicos con provincias afectadas y causas.'
  }, {
    icon: '🦕',
    title: 'ATLAS PALEONTOLÓGICO',
    desc: 'Mapa de sitios paleontológicos de Argentina. Tabla completa de dinosaurios argentinos con peso, longitud y provincia. Fauna extinta del Pleistoceno con causas de extinción.'
  }, {
    icon: '📊',
    title: 'ATLAS DE DATOS Y ESTADÍSTICAS',
    desc: 'Estadísticas de exportaciones mineras, reservas vs. mundo, producción de hidrocarburos y capacidad eléctrica instalada. Línea de tiempo del conocimiento geológico argentino desde 1787 hasta 2026.'
  }];
  return <section id="pricing" className="py-24 bg-[#ece2cd]" data-id="element-204">
      <div className="container mx-auto px-4" data-id="element-205">
        <div className="text-center mb-16" data-id="element-206">
          <h2 className="text-[28px] md:text-5xl font-black text-[#1e4230] mb-4 font-[Merriweather,_serif]" data-id="element-207">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-[#6f4e2e] text-[16px]" data-id="element-208">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto mb-10" data-id="element-209">
          {/* Opción 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-[0_16px_40px_-20px_rgba(31,50,39,0.4)] border border-[#e0d6bf] flex flex-col h-full relative z-10" data-id="element-210">
            <div className="mb-6" data-id="element-211">
              <p className="text-[#a97e12] font-bold uppercase tracking-wider text-sm mb-2" data-id="element-212">
                OPCIÓN 1 — Oferta principal
              </p>
              <h3 className="font-black text-[#1e4230] mb-2 flex items-center gap-2 text-[20px] font-[Merriweather,_serif]" data-id="element-213">
                🪨 MEGAPACK GEOLOGÍA LISTO™
              </h3>
              <p className="text-[#6f4e2e] font-medium" data-id="element-214">6 Tomos + 4 Bonos</p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#e0d6bf]" data-id="element-215"></div>

            <div className="mb-8" data-id="element-216">
              <div className="flex items-end gap-2" data-id="element-217">
                <span className="text-5xl font-black text-[#1e4230]" data-id="element-218">
                  $19.990
                </span>
                <span className="text-xl font-bold text-[#6f4e2e] mb-1" data-id="element-219">
                  ARS
                </span>
              </div>
              <p className="text-[#a08a6a] line-through mt-1" data-id="element-220">$45.000 ARS</p>
            </div>

            <ul className="space-y-3 mb-8 flex-grow" data-id="element-221">
              {baseFeatures.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-222">
                  <span className="text-[#4a4133] text-[15px]" data-id="element-223">{feature}</span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47976921825474:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-224">
              <Button variant="outline" size="lg" fullWidth data-id="element-225">
                🔥 QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Opción 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 shadow-[0_16px_40px_-20px_rgba(31,50,39,0.5)] border-2 border-[#c8971b] flex flex-col h-full relative z-10 transform lg:-translate-y-4" data-id="element-226">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-[#c8971b] text-[#14301f] font-black px-4 py-1 rounded-full text-sm uppercase tracking-wider flex items-center gap-1 shadow-lg" data-id="element-227">
              <Zap className="w-4 h-4 fill-[#14301f]" data-id="element-228" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-229">
              <h3 className="font-black text-[#1e4230] mb-2 flex items-center gap-2 text-[19px] font-[Merriweather,_serif]" data-id="element-230">
                🪨 MEGAPACK GEOLOGÍA LISTO™ + NIVEL EXPERTO
              </h3>
              <p className="text-[#a97e12] font-bold" data-id="element-231">
                Todo lo anterior + Atlas Profesional
              </p>
            </div>

            <div className="mb-6 pb-6 border-b border-[#e0d6bf]" data-id="element-232"></div>

            <div className="mb-8" data-id="element-233">
              <div className="flex items-end gap-2" data-id="element-234">
                <span className="text-5xl font-black text-[#1e4230]" data-id="element-235">
                  $27.990
                </span>
                <span className="text-xl font-bold text-[#6f4e2e] mb-1" data-id="element-236">
                  ARS
                </span>
              </div>
              <p className="text-[#a08a6a] line-through mt-1" data-id="element-237">$75.000 ARS</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-238">
              {expertoFeatures.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-239">
                  <Zap className="w-5 h-5 text-[#c8971b] shrink-0 mt-0.5" data-id="element-240" />
                  <span className={i === 10 ? 'text-[#1e4230] font-bold' : 'text-[#4a4133]'} data-id="element-241">
                    {feature}
                  </span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/47976933130434:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-242">
              <Button variant="premium" size="lg" fullWidth data-id="element-243">
                ⚡ QUIERO EL MEGAPACK + NIVEL EXPERTO
              </Button>
            </a>
          </motion.div>
        </div>

        <p className="text-center text-[#6f4e2e] text-sm mb-20" data-id="element-244">
          Podés pagar con tarjeta de crédito o débito, transferencia bancaria o
          Mercado Pago en pesos argentinos.
        </p>

        {/* Upsell Details */}
        <div className="max-w-4xl mx-auto" data-id="element-245">
          <div className="text-center mb-10" data-id="element-246">
            <h3 className="text-2xl md:text-3xl font-black text-[#1e4230] flex items-center justify-center gap-2 font-[Merriweather,_serif]" data-id="element-247">
              <Target className="w-8 h-8 text-[#c8971b]" data-id="element-248" />
              🎯 ¿QUÉ AGREGA EL NIVEL EXPERTO?
            </h3>
          </div>

          <div className="overflow-x-auto pb-4 mb-12" data-id="element-249">
            <div className="min-w-[700px]" data-id="element-250">
              <div className="grid grid-cols-3 gap-4 mb-4 px-4" data-id="element-251">
                <div className="font-bold text-[#6f4e2e] uppercase text-sm tracking-wider" data-id="element-252">
                  Situación
                </div>
                <div className="font-bold text-[#9c3f22] uppercase text-sm tracking-wider" data-id="element-253">
                  ❌ Sin Nivel Experto
                </div>
                <div className="font-bold text-[#2f6b47] uppercase text-sm tracking-wider" data-id="element-254">
                  ✅ Con Nivel Experto
                </div>
              </div>

              <div className="space-y-2" data-id="element-255">
                {comparisonRows.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 bg-white rounded-xl p-4 items-center border border-[#e0d6bf]" data-id="element-256">
                    <div className="text-[#1e4230] font-medium text-sm" data-id="element-257">
                      {row.sit}
                    </div>
                    <div className="text-[#9c3f22]/90 text-sm" data-id="element-258">{row.sin}</div>
                    <div className="text-[#1e4230] font-medium text-sm" data-id="element-259">
                      {row.con}
                    </div>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="bg-[#1e4230] rounded-2xl p-6 md:p-8 border-2 border-[#c8971b]/50 shadow-xl" data-id="element-260">
            <h4 className="font-black text-[#e7c766] mb-6 uppercase tracking-wider font-[Merriweather,_serif]" data-id="element-261">
              🗺️ NIVEL EXPERTO — ¿QUÉ INCLUYE?
            </h4>

            <h5 className="font-bold text-[#f5efe1] border-b border-[#2f6b47] pb-2 mb-6" data-id="element-262">
              🗺️ Atlas Profesional de Geología Argentina
            </h5>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-263">
              {atlas.map((item, i) => <div key={i} className="bg-[#14301f]/60 rounded-xl p-4 border border-[#2f6b47]/50" data-id="element-264">
                  <p className="font-bold text-[#f5efe1] flex items-center gap-2 mb-1" data-id="element-265">
                    <span className="text-[#e7c766] text-lg" data-id="element-266">{item.icon}</span>{' '}
                    {item.title}
                  </p>
                  <p className="text-[#c9d4c9] text-sm" data-id="element-267">{item.desc}</p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}